<script lang="ts">
  import { t } from 'svelte-i18n';
  import { setModalHash } from '../../shared/modal-store';

  export let element: HTMLElement = undefined;

  function openEmailFormModal() {
    setModalHash('contact-form');
  }
</script>

<section class="working-together">
  <p class="font-medium text-xxs md:text-sm md2:text-md xl:text-md2 pt-0 pb-8 md:pb-12 md2:pb-[3.5rem] lg:pb-[4.5rem] text-white opacity-[0.88]">{$t('HOME.WORKING.TITLE')}</p>

  <!-- group 1 -->
  <div class="working-together__container">
    <div class="working-together__decorator-container">
      <div class="w-[2px] h-16 md:h-24 md2:h-28 lg:h-32 lg:h-[4.5rem] bg-white-20 lg:bg-transparent lg:bg-home-stripe-up"></div>
      <div class="w-2 h-2 my-4 rounded-lg hidden lg:block bg-white-90"></div>
      <div class="w-[2px] flex-1 hidden lg:block bg-white-20"></div>
    </div>

    <div class="working-together__image-block--left">
      <h2 class="working-together__title">{$t('HOME.WORKING.TITLE1')}</h2>
      <p class="working-together__label"><a class="font-medium underline cursor-pointer" on:click={openEmailFormModal}>{$t('HOME.WORKING.SHARE')}</a>{@html $t('HOME.WORKING.DESCRIPTION1')}</p>
  
      <img class="h-auto w-full md2:w-[442px] lg:w-[396px] xl:w-[442px]" src="images/working-together-1.svg" alt="working together 1">
    </div>

    <div aria-hidden="true" class="hidden lg:block lg:order-3 lg:w-[calc(50%-4px)]"></div>
  </div>

  <!-- group 2 -->
  <div class="working-together__container">
    <div class="working-together__decorator-container">
      <div class="w-[2px] h-16 md:h-24 md2:h-28 lg:h-32 lg:h-[4.5rem] bg-white-20"></div>
      <div class="w-2 h-2 my-4 rounded-lg hidden lg:block bg-white-90"></div>
      <div class="w-[2px] flex-1 hidden lg:block bg-white-20"></div>
    </div>

    <div class="working-together__image-block--right">
      <h2 class="working-together__title">{$t('HOME.WORKING.TITLE2')}</h2>
      <p class="working-together__label">{@html $t('HOME.WORKING.DESCRIPTION2')}</p>
  
      <img class="h-auto w-full md2:w-[442px] lg:w-[396px] xl:w-[442px]" src="images/working-together-2.svg" alt="working together 2">
    </div>

    <div aria-hidden="true" class="hidden lg:block lg:order-1 lg:w-[calc(50%-4px)]"></div>
  </div>

  <!-- group 3 -->
  <div class="working-together__container">
    <div class="working-together__decorator-container">
      <div class="w-[2px] h-16 md:h-24 md2:h-28 lg:h-32 lg:h-[4.5rem] bg-white-20"></div>
      <div class="w-2 h-2 my-4 rounded-lg hidden lg:block bg-white-90"></div>
      <div class="w-[2px] flex-1 hidden lg:block bg-white-20"></div>
    </div>

    <div class="working-together__image-block--left">
      <h2 class="working-together__title">{$t('HOME.WORKING.TITLE3')}</h2>
      <p class="working-together__label">{@html $t('HOME.WORKING.DESCRIPTION3')}</p>
  
      <img class="h-auto w-full md2:w-[442px] lg:w-[396px] xl:w-[442px]" src="images/working-together-3.svg" alt="working together 3">
    </div>

    <div aria-hidden="true" class="hidden lg:block lg:order-3 lg:w-[calc(50%-4px)]"></div>
  </div>

  <!-- group 4 -->
  <div class="working-together__container">
    <div class="working-together__decorator-container">
      <div class="w-[2px] h-16 md:h-24 md2:h-28 lg:h-32 lg:h-[4.5rem] bg-white-20"></div>
      <div class="w-2 h-2 my-4 rounded-lg hidden lg:block bg-white-90"></div>
      <div class="w-[2px] flex-1 hidden lg:block bg-white-20 lg:bg-transparent lg:bg-home-stripe-down"></div>
    </div>

    <div class="working-together__image-block--right">
      <h2 class="working-together__title">{$t('HOME.WORKING.TITLE4')}</h2>
      <p class="working-together__label">{@html $t('HOME.WORKING.DESCRIPTION4')}</p>
  
      <img class="h-auto w-full md2:w-[442px] lg:w-[396px] xl:w-[442px] lg:pb-12" src="images/working-together-4.svg" alt="working together 4">
    </div>

    <div aria-hidden="true" class="hidden lg:block lg:order-1 lg:w-[calc(50%-4px)]"></div>
  </div>
  
  <!-- remaining decorator on tablet and mobile view -->
  <div class="flex flex-col items-center lg:hidden">
    <div class="w-[2px] h-[128px] md:h-[192px] block bg-home-stripe-down"></div>
  </div>
  <span class="absolute top-[calc(100vh-72px)]" bind:this={element} />
</section>

<style global lang="scss">
  .working-together {
    @apply relative flex flex-col items-center pt-16 sm:pt-20 md:pt-28 md2:pt-32 lg:pt-36 xl:pt-40 w-full bg-blue-bg z-20;
  }
  .working-together__container {
    @apply flex flex-col items-stretch lg:flex-row lg:w-full;
  }

  .working-together__decorator-container {
    @apply flex flex-col items-center order-1 lg:order-2;
  }

  .working-together__title {
    @apply text-white opacity-80 text-center lg:text-left text-base leading-[1.3] p-0 mb-3 xs:text-xxs sm:text-xs md2:text-sm xl:text-md;
    @apply md2:w-[442px] lg:w-[396px] lg:w-[396px] xl:w-[442px] selection:bg-text-dark selection:text-blue md3:max-w-[442px];
  }

  .working-together__image-block--left {
    @apply flex flex-col order-2 lg:order-1;

    @apply w-[266px] md:w-[365px] md2:w-[442px] lg:w-[396px] lg:w-[calc(50%-4px)];

    @apply py-[2.5rem] xs:py-12 md:py-[3.5rem] md2:pt-16 lg:py-[4.5rem] xl:py-20 md2:pb-[2.5rem] lg:items-end lg:pr-[4.5rem] xl:pr-[180px];
  }

  .working-together__image-block--right {
    @apply flex flex-col order-2 lg:order-3;

    @apply w-[266px] md:w-[365px] md2:w-[442px] lg:w-[396px] lg:w-[calc(50%-4px)];

    @apply py-[2.5rem] xs:py-12 md:py-[3.5rem] md2:pt-16 lg:py-[4.5rem] xl:py-20 md2:pb-[2.5rem] lg:items-start lg:pl-[4.5rem] xl:pl-[180px];
  }

  .working-together__label {
    @apply md2:w-[442px] lg:w-[396px] lg:w-[396px] xl:w-[442px] selection:bg-text-dark selection:text-blue md3:max-w-[442px] font-light text-center lg:text-left text-white opacity-60 leading-[150%] pt-0 pb-8 md:pb-12 md2:pb-[3.5rem] lg:pb-16 text-base md:text-xs md2:text-sm;
    
    strong {
      font-weight: 500;
    }
  }
</style>